/**
 * Link auf eine Datei der API (Label-PDF/ZPL, Beleg-PDF, CSV). Öffnet in neuem
 * Tab (Browser-Druck, Ruling R6). Im Mock-Modus liefert die Mock-Schicht ein Blob.
 */
import { useEffect, useState, type ReactNode } from 'react';
import { dateiUrl } from '../api/http';
import { mockModus } from '../api/mock';

export function DateiLink({ pfad, children, className, download, testid }: { pfad: string; children: ReactNode; className?: string; download?: string; testid?: string }) {
  const [url, setUrl] = useState<string | null>(mockModus() === 'aus' ? `/api${pfad}` : null);
  useEffect(() => {
    if (mockModus() === 'aus') { setUrl(`/api${pfad}`); return; }
    let aktiv = true;
    dateiUrl(pfad).then((u) => { if (aktiv) setUrl(u); });
    return () => { aktiv = false; };
  }, [pfad]);
  return (
    <a href={url ?? undefined} target="_blank" rel="noopener" className={className} download={download} data-testid={testid}
      aria-disabled={!url} onMouseDown={(e) => e.preventDefault()}>
      {children}
    </a>
  );
}

/** Datei sofort in neuem Tab öffnen (z. B. Label nach dem Erzeugen). Kann vom Popup-Blocker verhindert werden; der Link bleibt sichtbar. */
export async function oeffneDatei(pfad: string): Promise<void> {
  const url = await dateiUrl(pfad);
  window.open(url, '_blank', 'noopener');
}
